export default {
  api: {
    url: 'https://devapi.datedish.com/datedish/api/v1/',
    mode: 'cors'
  },
  config: {
  }

}
